<template>
  <div
    class="tw:flex tw:justify-between tw:border-b tw:border-denim-200 tw:p-5 tw:pt-0"
  >
    <div class="tw:min-w-32 tw:flex tw:items-center">
      <slot name="title" />
    </div>
    <div class="tw:grow tw:flex tw:items-center">
      <slot name="content">
        <OutreachContactProfileContent v-model="showAll">
          <slot />
        </OutreachContactProfileContent>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import OutreachContactProfileContent from "src/components/Outreach/OutreachContactProfileContent.vue";

const showAll = defineModel<boolean>({
  default: false,
});
</script>
